(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hl-motion"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const root = document.getElementById('MainContent') || document.querySelector('main');
  if (!root) return;
  const secs = Array.from(root.querySelectorAll(':scope > .shopify-section')).filter(s => !s.querySelector('.hl-motion'));
  if (!secs.length) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('hl-in'); io.unobserve(e.target); } });
  }, { threshold: 0.06, rootMargin: '0px 0px -6% 0px' });
  secs.slice(1).forEach(s => { s.classList.add('hl-reveal'); io.observe(s); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
